import styled from 'styled-components';

// Divider placed by offset from the bottom of its container. Prefer
// PanelFooter for a divider above a panel's buttons; this one draws the
// same line for the in-game layouts that still position it by hand.
export const Bar = styled('div')`
  height: 10px;
  width: 160%;
  border-bottom: 1px solid var(--border);
  position: absolute;
  bottom: 90px;
  left: -40px;
`;
